class ScheduleRule {
  constructor(json = {}) {
    if (!Array.isArray(json.weekdays)) {
      json.weekdays = [];
    }
    this.pkScheduleRule = json.pk_schedule_rule
    this.isDeleted = json.is_deleted
    this.startDate = json.start_date
    this.endDate = json.end_date ? json.end_date : ''
    this.weekdays = json.weekdays.map(day => day.day)
    this.name = json.name
    this.hour = json.hour
    this.tag = json.tag
  }
}

export default ScheduleRule


// WEBPACK FOOTER //
// ./src/models/ScheduleRule.js